import { produce } from 'immer';
import { equals } from 'ramda';

import * as Types from '../types';
import { actionTypes } from './constants';

export const defaultState: Types.II18nState = {
    translations: {},
    defaultTranslations: {},
    showTranslationKeys: false
};

export const reducer = produce((draftState, action: Types.TI18nAction): Types.II18nState | void => {
    switch (action.type) {
        case actionTypes.ADD_TRANSLATIONS: {
            const translations = {
                ...draftState.translations,
                ...action.payload.translations
            };

            if (!equals(translations, draftState.translations)) {
                Object.assign(draftState, {
                    translations
                });
            }

            break;
        }

        case actionTypes.SET_DEFAULT_TRANSLATIONS: {
            const defaultTranslations = {
                ...draftState.defaultTranslations,
                ...action.payload.defaultTranslations
            };

            if (!equals(defaultTranslations, draftState.defaultTranslations)) {
                Object.assign(draftState, {
                    defaultTranslations
                });
            }

            break;
        }

        case actionTypes.SHOW_TRANSLATION_KEYS: {
            Object.assign(draftState, {
                showTranslationKeys: action.payload
            });

            break;
        }

        case actionTypes.CLEAR_TRANSLATIONS: {
            Object.assign(draftState, {
                translations: {}
            });

            break;
        }

        default:
            break;
    }
}, defaultState);
